import Button from '@/components/atoms/Button'
import Icon from '@/components/atoms/Icon'
import Modal from '@/components/atoms/Modal'
import { modalCreators } from '@/store/ducks/modal'
import { useAppDispatch } from '@/store/hooks'
import { Dialog } from '@headlessui/react'

interface NewJourneyProps {
	disabledOnClose?: boolean
}

export function NewJourney({ disabledOnClose }: NewJourneyProps) {
	const dispatch = useAppDispatch()

	async function closeModal() {
		await dispatch(modalCreators.closeModal())
	}

	return (
		<Modal
			name='newJourneyModal'
			disabledOnClose={disabledOnClose}
			className='relative py-12 md:px-12 md:py-16 max-w-[740px] overflow-clip dark:bg-modal-new-journey rounded-2xl'
		>
			<div className='absolute -top-2 sm:-top-5 left-0 right-0 z-0'>
				<img
					src={`/imgs/admin/modals/title-journey.png`}
					width='100%'
					height='auto'
					alt='Imagem de spray no modal whatsapp'
				/>
			</div>

			<div className='absolute top-0 left-0'>
				<img
					src={`/imgs/admin/modals/journey-top-left.png`}
					width='293px'
					height='auto'
					alt='Imagem de spray no modal whatsapp'
				/>
			</div>
			<div className='flex flex-col items-center gap-8 md:gap-12'>
				<div className='flex flex-col gap-7 items-center'>
					<Icon
						name='journey'
						className='text-white'
						width='194px'
						height='71px'
					/>
					<div className='flex flex-col items-center gap-5'>
						<div className='relative'>
							<Dialog.Title
								as='h3'
								className='relative text-4xl md:text-5xl font-bold leading-[120%] text-[#FBFAFE] z-10'
							>
								Nova jornada desbloqueada
							</Dialog.Title>
							<span className='absolute -top-32 -right-32 md:-right-6 z-0'>
								<img
									src={`/imgs/admin/modals/new-journey-title.png`}
									width='325px'
									height='auto'
									alt='Imagem de spray no modal whatsapp'
									className='w-[305px] md:w-[325px]'
								/>
							</span>
						</div>
						<p className='w-full text-lg md:text-xl lg:text-2xl font-medium text-white/80 leading-[150%] max-w-[650px]'>
							Você está prestes a começar uma nova jornada de aprendizado
							completa. Você está preparado(a) para evoluir na sua carreira
							profissional?
						</p>
					</div>
				</div>
				<Button
					className='flex w-full max-w-max h-auto text-zinc-50 bg-zinc-800 hover:bg-zinc-800/90 py-[10px] rounded-full px-6'
					onClick={() => closeModal()}
				>
					<p className='text-[15px] xs:text-lg lg:text-xl'>
						Estou pronto para a jornada!
					</p>
				</Button>
			</div>

			<div className='absolute -bottom-2 sm:-bottom-6 left-0 right-0 z-0'>
				<img
					src={`/imgs/admin/modals/title-journey.png`}
					width='100%'
					height='auto'
					alt='Imagem de spray no modal whatsapp'
				/>
			</div>
		</Modal>
	)
}
